export const validation = {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  maxPostTitleChar: 65,
  maxPostParagraphChar: 650
}
